module.exports = __webpack_public_path__ + "static/media/phone.670c76cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phone.svg
// module id = 161
// module chunks = 21